import { h } from '@stencil/core';

import { ContainerSize } from '../interfaces';

export function responsiveContainer(
  render: (size: ContainerSize) => void,
  minsize: { '5xs': number; '4xs': number; '3xs': number; xs: number; sm: number; md: number; lg: number; xl: number; '2xl': number } = undefined
) {
  return <width-observer renderer={render} minSizes={minsize}></width-observer>;
}
